exports = module.exports = require("./../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".matrix-container{position:relative}.matrix-container .matrix-entry-container{position:absolute;display:flex;align-items:center;justify-content:center}.matrix-container .matrix-entry-container .right-row-label{transform:rotate(-45deg)}.matrix-container .matrix-entry-container .matrix-entry-input{width:100%;background-color:transparent;text-align:center;border:none}.matrix-container .matrix-entry-container .matrix-entry-input.invalid{border:1px solid red}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/code/UI/Math/Matrix.scss
// module id = 73
// module chunks = 0